import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-overview-detail-card',
  templateUrl: './overview-detail-card.component.html',
  styleUrls: ['./overview-detail-card.component.scss'],
  standalone: false,
})
export class OverviewDetailCardComponent {
  @Input() title!: string;
  @Input() number!: number;
  @Input() iconKey!: string;
  @Input() symbol?: string | null;
  @Input() color?: string | null;

  get symbolMaskUrl(): string {
    return this.symbol
      ? `url("assets/icons/v3-bps/symbol-modal/${this.symbol}.svg")`
      : '';
  }

  get iconColor(): string {
    return this.color || '#666';
  }
  @Input() countIncrease?: number;
  @Input() percentage?: number;
  @Input() useDetails: boolean = false;
  @Input() seeBreakdownVisible: boolean = false;

  @Output() detailsClicked = new EventEmitter<void>();
}
